import React, { useState } from "react";
import CalculatorCard from "../../components/CalculatorCard";
import PageSeo from "../../components/PageSeo";
import { Helmet } from "react-helmet-async";

export default function FuelCalculator() {
  const [distance, setDistance] = useState("");
  const [mileage, setMileage] = useState("");
  const [price, setPrice] = useState("");
  const [result, setResult] = useState(null);

  const calculateFuel = () => {
    const d = Number(distance);
    const m = Number(mileage);
    const p = Number(price);

    if (!d || !m || !p) return;

    const total = (d / m) * p;
    setResult(Math.round(total)); // ✅ FIXED
  };

  const shareOnWhatsApp = () => {
    const text = encodeURIComponent(`Check my calculation result: ₹ ${result} | MotoHub India https://motohubindia.com`);
    const url = window.innerWidth < 768 
      ? `whatsapp://send?text=${text}` 
      : `https://web.whatsapp.com/send?text=${text}`;
    window.open(url, '_blank');
  };

  const downloadPDF = () => {
    const el = document.getElementById('calculator-result');
    const original = document.title;
    document.title = 'MotoHub-Calculation-Result';
    window.print();
    document.title = original;
  };

  return (
    <>
      <Helmet>
        <title>Bike Fuel Cost Calculator India | Petrol Cost Estimator | MotoHub India</title>
        <meta
          name="description"
          content="Calculate fuel cost for your bike ride in India. Estimate petrol expense using distance, mileage and fuel price with MotoHub fuel calculator."
        />
        <meta
          name="keywords"
          content="bike fuel calculator India, petrol cost bike India, motorcycle fuel cost calculator, trip fuel estimator India"
        />
        <link rel="canonical" href="https://motohubindia.com/calculator/fuel" />
        <meta property="og:title" content="Bike Fuel Cost Calculator | MotoHub India" />
        <meta property="og:description" content="Estimate your bike fuel expenses easily." />
        <meta property="og:url" content="https://motohubindia.com/calculator/fuel" />
      </Helmet>

      <div style={{ padding: "30px" }}>
        <PageSeo
          title="Bike Fuel Cost Calculator India | MotoHub"
          description="Estimate fuel cost for bike rides in India."
          path="/calculator/fuel"
        />

        <CalculatorCard title="Fuel Cost Calculator">
          <div style={seoBox}>
            <h2>Bike Fuel Cost Calculator India</h2>
            <p style={seoText}>
              Use MotoHub India fuel calculator to estimate your motorcycle fuel expenses. 
              Enter distance, bike mileage, and fuel price to calculate total petrol cost instantly.
            </p>
            <p style={seoText}>
              This tool helps riders plan long trips, daily commuting costs, and budget for fuel expenses in India.
            </p>
          </div>

          <input
            placeholder="Distance (km)"
            value={distance}
            onChange={(e) => setDistance(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Mileage (km/l)"
            value={mileage}
            onChange={(e) => setMileage(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Fuel Price (Rs/l)"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            style={inputStyle}
          />

          <button style={buttonStyle} onClick={calculateFuel}>
            Calculate Fuel Cost
          </button>

          <div id="calculator-result">
            {result && (
              <>
                <h3 style={{ marginTop: "20px" }}>
                  Total Cost: ₹ {result}
                </h3>
                <div className="flex space-x-4">
                  <button onClick={shareOnWhatsApp} 
                    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm">
                    Share on WhatsApp
                  </button>
                  <button onClick={downloadPDF}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm">
                    Download PDF
                  </button>
                </div>
              </>
            )}
          </div>
        </CalculatorCard>
      </div>
    </>
  );
}

// Styles
const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "10px",
  borderRadius: "10px",
  border: "1px solid #333",
  background: "#1a1a1a",
  color: "#fff"
};

const buttonStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "10px",
  border: "none",
  background: "linear-gradient(90deg, #ff4d00, #ff7a00)",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px"
};

const seoBox = {
  marginBottom: "20px",
  background: "#111",
  padding: "15px",
  borderRadius: "10px",
  border: "1px solid #222"
};

const seoText = {
  color: "#aaa",
  lineHeight: "1.6",
  marginTop: "8px"
};